import { Injectable } from '@angular/core';
import { Device } from '@ionic-native/device';
import { UniqueDeviceID } from '@ionic-native/unique-device-id';
import { Events } from 'ionic-angular';
import { PushConfig, PushMessage, writeValueOnConfig, readValueFromConfig, randomString, arrayContainsAndPush } from './util';
import { AppVersion } from '@ionic-native/app-version';
import * as Fingerprint2 from 'fingerprintjs2';

var pushServiceInstance: PushServiceAbs;

@Injectable()
export abstract class PushServiceAbs {

    private appDomain: string;
    private codEmpresa = 9; //trocar quando gerar nova versão

    constructor(public events: Events, protected device: Device, private uniqueDeviceID: UniqueDeviceID, private appVersion: AppVersion) {
        pushServiceInstance = this;
        pushServiceInstance.appDomain = "brcomunique_lince"; // trocar quando gerar nova versão
        this.events.subscribe("push:checkmsg", this.checkMsgServer);
    }

    abstract buildConfig(): PushConfig;
    abstract async deviceRegistered(deviceCode: string, idDevice: number);
    abstract onPushMessage(msg: PushMessage);
    abstract buildLocalNotification(msg: PushMessage): any;
    abstract onNotificationClick(payload: any);
    protected abstract initPush();
    abstract onProcessLastMessage(msg: any, local:string);

    public localStorageKeyName(): string {
        var ip: any;
        ip = pushServiceInstance.buildConfig().serverIp;
        while (ip.indexOf(".") != -1)
            ip = ip.replace('.', '_');
        while (ip.indexOf(":") != -1)
            ip = ip.replace(':', '_');
        let r = "push_info_" + pushServiceInstance.appDomain + "_" + ip;
        return r;
    }

    public getIdDevice(): number {
        return readValueFromConfig(pushServiceInstance.localStorageKeyName(), "idDevice");
    }

    public getDeviceCode(): string {
        return readValueFromConfig(pushServiceInstance.localStorageKeyName(), "deviceCode");
    }

    public async init() {
        try {
            // adicionar o valor do domain para this.appDomain, que é utilizado pela classe
            //this.readAppDomain();

            // cria os listeners de notificação, registra uma chave para o aparelho e busca o device no servidor
            this.initPush();
          //  await pushServiceInstance.checkMsgServer();
        } catch (e) {
        }
        /*
        if (this.device && this.device.platform) {//&& (!this.device.isVirtual)
            
        } else {
            pushServiceInstance.appDomain = "brcomunique_aprasc";
            this.registerOnGoPushServer("");
            return;
        }*/
    }

    private receivedMessage(idMessage: number, payload: any, title: string, text: string, msgOrigin: string, foreground: boolean) {
        //console.log("pushservice:RECEIVED MESSAGE idMessage[" + idMessage + "]");
        //console.log("pushservice:RECEIVED MESSAGE payload[" + JSON.stringify(payload) + "]");
        //console.log("pushservice:RECEIVED MESSAGE title[" + title + "]");
        //console.log("pushservice:RECEIVED MESSAGE text[" + text + "]");
        //console.log("pushservice:RECEIVED MESSAGE msgOrigin[" + msgOrigin + "]");
        //console.log("pushservice:RECEIVED MESSAGE foreground[" + foreground + "]");
        let found = arrayContainsAndPush("idAlreadyProcessedMessages", idMessage);
        if (found) {
            //console.log("pushservice:RECEIVED MESSAGE WIDH ID [" + idMessage + "] ALREADY PROCESSED ");
            return;
        }
        let msg = new PushMessage(idMessage, payload, title, text, foreground);
        pushServiceInstance.onPushMessage(msg);
    }

    protected onNotification(notification: any) {
        //console.log("pushservice:PUSH FROM NETWORK ON " + new Date());
        //console.log("pushservice:PUSH FROM NETWORK :" + JSON.stringify(notification));
//        alert("pushservice:PUSH FROM NETWORK :" + JSON.stringify(notification));
        if ((!notification) || (!notification.additionalData) || (!notification.additionalData.dados) || (!notification.additionalData.dados.payload))
            return;
        pushServiceInstance.receivedMessage(notification.additionalData.dados.idMessage, notification.additionalData.dados.payload, notification.additionalData.notificacao.titulo, notification.additionalData.notificacao.texto, "NETWORK", notification.additionalData.foreground);
    }

    public checkMsgServer():Promise<any> {
        return new Promise((resolve, reject) => {
            var idDevice = readValueFromConfig(pushServiceInstance.localStorageKeyName(), "idDevice");
           // //console.log("pushservice:checkMsgServer:"+idDevice);
            if (!idDevice)
                return;
            var prevLastMessage = readValueFromConfig(pushServiceInstance.localStorageKeyName(), "lastMessage");
            let param = {
                idDevice: idDevice
            };
            var firstCall = false;
            if (prevLastMessage)
                param["lastMessage"] = prevLastMessage;
            else
                firstCall = true;
           // //console.log("pushservice:checkMsgServer:idDevice:" + idDevice);
            pushServiceInstance.remoteInternal("read", param, function (result: any) {
                if (!result.ok) {
             //       //console.log("pushservice:read returned error. ignored.");
                    reject();
                    return;
                }
                var lastMessageOnPackage = 0;
                for (let msg of result.messages) {
                    //console.log("pushservice:PUSH AJAX :" + JSON.stringify(msg));
                    if (!firstCall)
                        pushServiceInstance.receivedMessage(msg['idMessage'], msg['message'], msg['title'], msg['text'], "AJAX", false);
                    if (msg.idMessage > lastMessageOnPackage)
                        lastMessageOnPackage = msg.idMessage;
                }
                if (result.messages.length==0)  {
                    if (firstCall) {
                        // para simular é deixar o prevlastMessage = null e result.mensagens = []
                        // o resultado da primeira chamada é sempre ignorado, mas caso a primeira retornar vazio
                        // a próxima chamada ainda é considerada uma primeira chamada
                        // se a chamada for a primeira e retornar vazio o lastMessage deve ficar com o valor -1, 
                        // para na próxima vez ter um valor no prevLastMessage e não ser considerada a primeira e ignorar o resultado
                        // é colocado -1 ao invés de 0 pois 0 é falsy
                        writeValueOnConfig(pushServiceInstance.localStorageKeyName(), "lastMessage", -1);
                    }
                    resolve(null);
                } else {
                    resolve(result.messages[result.messages.length-1]);
                }
                if (lastMessageOnPackage > prevLastMessage) {
                    writeValueOnConfig(pushServiceInstance.localStorageKeyName(), "lastMessage", lastMessageOnPackage);
                }
            })
        }); 
    }

    private async readDeviceCode(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            // é recomendado pelo criador do Fingerprint2 que se espere meio segundo para carregar a página antes de buscar os valores
            setTimeout( () => {
                Fingerprint2.get( (components) => {
                  var values = components.map(function (component) { return component.value });
                  var murmur = Fingerprint2.x64hash128(values.join(''), this.codEmpresa); //seed cod da empresa, assim no mesmo computador e browser o idDevice é diferente
                  writeValueOnConfig(pushServiceInstance.localStorageKeyName(), "deviceCode", murmur);
                  resolve(murmur);
                })  
            }, 500);
        })

        
        /*if (this.device.platform) {
            let deviceCode = await this.uniqueDeviceID.get();
            writeValueOnConfig(pushServiceInstance.localStorageKeyName(), "deviceCode", deviceCode);
            //console.log("pushservice:deviceCode from real device:" + deviceCode);
            return deviceCode;
        } else {
            let deviceCode = readValueFromConfig(pushServiceInstance.localStorageKeyName(), "deviceCode");
            //console.log("pushservice:read deviceCode:" + deviceCode);
            if (!deviceCode) {
                deviceCode = randomString(4) + "-" + randomString(4) + "-" + randomString(4) + "-" + randomString(4);
                writeValueOnConfig(pushServiceInstance.localStorageKeyName(), "deviceCode", deviceCode);
                //console.log("pushservice:deviceCode from random number:" + deviceCode);
            }
            return deviceCode;
        }*/
    }

    private readAppDomain() {
       /* var nome = "brcomunique";
        try {
            var pn = await pushServiceInstance.appVersion.getPackageName();
            pn = pn.substring(pn.indexOf('.mobile')+8);
            if (pn!="") {
              nome += "_" + pn;
            }
        } catch (e) {
        }
       pushServiceInstance.appDomain = nome;*/
    }

    protected async registerOnGoPushServer(pushCode: string) {
        let deviceCode = await this.readDeviceCode();
        if (pushCode == "")
            pushCode = deviceCode;
        //writeValueOnConfig(pushServiceInstance.localStorageKeyName(), "pushCode", pushCode);

         /*var devicePlatform: string;
       if (this.device.platform) {
            devicePlatform = this.device.platform;
            if (devicePlatform == "Android")
                devicePlatform = "D";
            if (devicePlatform == "iOS")
                devicePlatform = "P";
        }
        else
            devicePlatform = "B";*/

        try {
            let params = {
                mobileId: deviceCode,
                pushCode: pushCode,
                deviceModel: this.device.model,
                devicePlatform: "W",
                deviceVersion: this.device.version,
                deviceSerial: this.device.serial,
                deviceManufacturer: this.device.manufacturer,
                domainApp: pushServiceInstance.appDomain
            };
            let _this = this;
            this.remoteInternal("register", params, function (result) {
                if (!result.ok) {
                    //console.log("pushservice:"+result.msg);
                    return;
                }
                try {
                    writeValueOnConfig(pushServiceInstance.localStorageKeyName(), "idDevice", result.id);
                    _this.deviceRegistered(deviceCode, result.id);
                } catch (er) {
                    console.log("pushservice:"+er);
                }
            });
            if (!pushServiceInstance.device.platform) {
               // setInterval(pushServiceInstance.checkMsgServer, 10000);
            }
        } catch (e) {
            console.log("pushservice:"+e);
        }
    }

    private remoteInternal(url: string, params: any, cb: (result: any) => void) {
        let xhr = new XMLHttpRequest();
        url = "https://" + pushServiceInstance.buildConfig().serverIp + "/gopush/" + url;
        xhr.open('POST', url, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.onload = function () {
            var result = JSON.parse(xhr.responseText);
          //  console.log("pushservice:CALL OK TO " + url + " " + JSON.stringify(params) + " " + xhr.responseText);
            cb(result);
        };
        xhr.onerror = function (error: any) {
         //   console.log("pushservice:CALL ERROR TO " + url + " " + JSON.stringify(params) + " " + xhr.responseText + " with error [" + JSON.stringify(error) + "]");
        }
        let pp = "";
        for (let p in params) {
            let value = params[p];
            if (value != null) {
                if (pp == "")
                    pp = p + "=" + value;
                else
                    pp = pp + "&" + p + "=" + value;
            }
        }
        xhr.send(pp);
    }

}


// WEBPACK FOOTER //
// ./src/lib/pushserviceabs.ts